import script from "./EditStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./EditStatusModal.vue?vue&type=style&index=0&id=8d54c1b2&scoped=true&lang=css"
import "./EditStatusModal.vue?vue&type=style&index=1&id=8d54c1b2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d54c1b2"]])

export default __exports__